import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ActionsPage } from './pages/ActionsPage';
import { ImpactPage } from './pages/ImpactPage';
import { BlogPage } from './pages/BlogPage';
import { ArticlePage } from './pages/ArticlePage';
import { DonatePage } from './pages/DonatePage';
import { PartnerPage } from './pages/PartnerPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { FormateursPage } from './pages/FormateursPage';
import { BenevolesPage } from './pages/BenevolesPage';
import { PromaisonPage } from './pages/PromaisonPage';
import { PromaisonPopup } from './components/PromaisonPopup';
// ScrollToTop component to ensure page starts at top on navigation
function ScrollToTop() {
  const {
    useLocation
  } = require('react-router-dom');
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <PromaisonPopup data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
        <Route path="/about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
        <Route path="/actions" element={<ActionsPage data-id="element-9" />} data-id="element-8" />
        <Route path="/impact" element={<ImpactPage data-id="element-11" />} data-id="element-10" />
        <Route path="/blog" element={<BlogPage data-id="element-13" />} data-id="element-12" />
        <Route path="/blog/article/:id" element={<ArticlePage data-id="element-15" />} data-id="element-14" />
        <Route path="/donate" element={<DonatePage data-id="element-17" />} data-id="element-16" />
        <Route path="/partner" element={<PartnerPage data-id="element-19" />} data-id="element-18" />
        <Route path="/admin" element={<AdminDashboard data-id="element-21" />} data-id="element-20" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-23" />} data-id="element-22" />
        <Route path="/formateurs" element={<FormateursPage data-id="element-25" />} data-id="element-24" />
        <Route path="/benevoles" element={<BenevolesPage data-id="element-27" />} data-id="element-26" />
        <Route path="/promaison" element={<PromaisonPage data-id="element-29" />} data-id="element-28" />
      </Routes>
    </Router>;
}